import { useMutation } from '@tanstack/react-query';
import { triggerChatWorkflow } from '@/services/DataService';

export const useChatWorkflow = () => {
  return useMutation({
    mutationFn: (payload: { trigger_workflow: { workflow_instance_id: string } }) =>
      triggerChatWorkflow(payload),
  });
};